import { Stack, TextField, Typography, Box } from '@mui/material'
import { FieldDef } from '../types'

interface YearPoint {
  year: number
  value: number
}

interface Props {
  field: FieldDef
  value: YearPoint[]
  onChange: (v: YearPoint[]) => void
}

export default function TrajectoryWidget({ field, value, onChange }: Props) {
  const years = field.years || 10
  // Ensure the array is always length=years with sequential year numbers
  const safe: YearPoint[] = Array.from({ length: years }, (_, i) => {
    const existing = (value || []).find((p) => p.year === i + 1)
    return existing || { year: i + 1, value: 0 }
  })

  const update = (year: number, v: number) => {
    const next = safe.map((p) => (p.year === year ? { ...p, value: v } : p))
    onChange(next)
  }

  return (
    <Stack spacing={1}>
      <Typography variant="caption" color="text.secondary">
        {field.label} (USD per year)
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 1 }}>
        {safe.map((p) => (
          <TextField
            key={p.year}
            type="number"
            label={`Year ${p.year}`}
            value={p.value || ''}
            onChange={(e) => update(p.year, e.target.value === '' ? 0 : Number(e.target.value))}
            size="small"
          />
        ))}
      </Box>
    </Stack>
  )
}
